import { defineComponent as _defineComponent } from 'vue'
import {
  AtomButton,
  AtomInput,
  DeleteIcon,
  EditSquareIcon,
} from '@/components/atoms';
import { MoleculeTable, MoleculeModal, MoleculeTitleSetings } from '@/components/molecules';
import { Provedor } from '@/core/models';

import { IHeadersTable } from '@/types';
import { ref, onMounted, watch } from 'vue';
import Swal from 'sweetalert2';
import { Preloader } from '@/store';
import { getProvedorAll, postProvedor, putProvedor } from '@/core/services/ProvedorService';
interface IProps {
  activeTab: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProviderPage',
  props: {
    activeTab: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const sortable = ref<any>();
const data = ref<Provedor>({});
const perPage = ref<number>(10);
const page = ref<number>(1);
const totalItems = ref<number>(0);
const term = ref<string>('');
const showModalUpload = ref<boolean>(false);
const headers = ref<IHeadersTable[]>([
  {
    label: 'Id',
    field: 'id',
  },
  { label: 'Nome', field: 'nome' },
  { label: 'CNPJ', field: 'provedorCnpj' },
  { label: 'Telefone', field: 'provedorTelefone' },
  { label: 'Opções', field: 'actions' },
]);
const items = ref<any[]>([]);

const addNew = ref<boolean>(false);
  const type = ref<string>();
  function replacement(){
  if(addNew.value == false){
    addNew.value = true;
    type.value = 'C';
  }else{
    addNew.value = false;
    type.value = '';
  }
}

function handleEdit(payload: Provedor, isApp:boolean = false) {
  console.log(payload, 'Edit');

  data.value = JSON.parse(JSON.stringify(payload));



  type.value = 'E';
  
  if(isApp){
    addNew.value = true;
  } else {
    showModalUpload.value = true;
  }
}
function clear() {
  data.value = {};
  data.value.id = 0;
}

function handleDelete(payload: Provedor) {
  console.log(payload, 'Delete');

  Swal.fire({
    title: '<strong>Atenção</strong>',
    icon: 'question',
    html: `Deseja realmente arquivar o Provedor <b>${payload.nome}</b>? `,
    showCloseButton: true,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
  }).then((ale) => {
    if (ale.isConfirmed) {
      Preloader.actions.ActionSetPreloader(true);
      payload.archived = 1;
      putProvedor(payload)
        .then((resp) => {
          if (resp) {
            Swal.fire({
              title: 'Sucesso',
              text: `Provedor ${payload.nome} foi arquivado com sucesso!`,
              icon: 'success',
            });
          }
          loadData();
        })

        .finally(() => {
          Preloader.actions.ActionSetPreloader(false);
        });
    }
  });
}
function searching(event: string | undefined) {
  page.value = 1;
  term.value = String(event);
  // loadData();
}

function handleAddOrUpdate() {
  Preloader.actions.ActionSetPreloader(true);
  if (data.value?.id == 0) {
    data.value.archived = 0;
    data.value.id = undefined;
    postProvedor(data.value)
      .then(() => {
        // Swall
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: `Provedor ${data.value?.nome} foi criado com sucesso!`,
        });
        loadData();
        showModalUpload.value = false;
      })

      .finally(() => {
        data.value = {}
        addNew.value = false
        Preloader.actions.ActionSetPreloader(false);
      });
  } else {
    putProvedor(data.value as Provedor)
      .then(() => {
        // swall
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: `Provedor ${data.value?.nome} foi atualizado com sucesso!`,
        });
        loadData();
        showModalUpload.value = false;
      })

      .finally(() => {
        data.value = {}
        addNew.value = false
        Preloader.actions.ActionSetPreloader(false);
      });
  }
}

function sort(event) {
  let typ = {};
  if (event.type == 'none') {
    typ = undefined;
  } else {
    typ[event.field] = event.type;
  }
  sortable.value = typ;
  loadData();
}
function loadData() {
  Preloader.actions.ActionSetPreloader(true);
  totalItems.value = 0;

  let promisse;

  if (sortable.value) {
    promisse = getProvedorAll(page.value - 1, perPage.value, term.value, sortable.value);
  } else {
    promisse = getProvedorAll(page.value - 1, perPage.value, term.value);
  }
  promisse
    .then((resp) => {
      items.value = resp.lista;
      totalItems.value = resp.totalItems-  items.value.filter(f=>f.archived == 1).length;
    })

    .finally(() => {
      Preloader.actions.ActionSetPreloader(false);
    });
}

watch(
  () => props.activeTab,
  () => {
    if (props.activeTab === 'provedor') {
      page.value = 1;
      loadData();
    }
  }
);

watch(
  () => page.value,
  () => {
    loadData();
  }
);

watch(
  () => term.value,
  () => {
    loadData();
  }
);

watch(
  () => perPage.value,
  () => {
    loadData();
  }
);
onMounted(() => {
  loadData();
});

const __returned__ = { props, sortable, data, perPage, page, totalItems, term, showModalUpload, headers, items, addNew, type, replacement, handleEdit, clear, handleDelete, searching, handleAddOrUpdate, sort, loadData, get AtomButton() { return AtomButton }, get AtomInput() { return AtomInput }, get DeleteIcon() { return DeleteIcon }, get EditSquareIcon() { return EditSquareIcon }, get MoleculeTable() { return MoleculeTable }, get MoleculeModal() { return MoleculeModal }, get MoleculeTitleSetings() { return MoleculeTitleSetings } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})